import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getStudioList = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/schedule-ruleset/studios` });

  return data?.data;
};

export default getStudioList;
